(() => {
  function addBusinessDays(date, days) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay(); // 0 Sun, 6 Sat
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function parseIntSafe(v, d=0){ const n = parseInt(v,10); return isNaN(n) ? d : n; }

  function computeAndRender(root){
    if(!root) return;

    const fmt = new Intl.DateTimeFormat(undefined, { weekday:'short', month:'short', day:'numeric' });

    const country = (root.dataset.country || '').toUpperCase();
    const handling = parseIntSafe(root.dataset.handling, 1);
    const lead     = parseIntSafe(root.dataset.lead, 0);

    const domesticList = (root.dataset.domesticCountries || 'US')
      .toUpperCase().split(',').map(s => s.trim()).filter(Boolean);

    const isDomestic = domesticList.includes(country);

    const minDays = parseIntSafe(isDomestic ? root.dataset.domesticMin : root.dataset.internationalMin, isDomestic ? 3 : 7);
    const maxDays = parseIntSafe(isDomestic ? root.dataset.domesticMax : root.dataset.internationalMax, isDomestic ? 5 : 12);

    const today = new Date();
    const base = handling + lead;

    const start = addBusinessDays(today, base + minDays);
    const end   = addBusinessDays(today, base + maxDays);

    const out = root.querySelector('.krak-estimate__dates');
    if (out) out.textContent = `${fmt.format(start)} – ${fmt.format(end)}`;
  }

  function init(){
    document.querySelectorAll('#krak-delivery-estimate').forEach(computeAndRender);
  }

  // Dawn/OS 2.0 section loads (product template often renders dynamically)
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:change', init);
})();
